import { render, staticRenderFns } from "./RemittanceOperationManagementReport.vue?vue&type=template&id=cff9cd30&scoped=true"
import script from "./RemittanceOperationManagementReport.vue?vue&type=script&lang=js"
export * from "./RemittanceOperationManagementReport.vue?vue&type=script&lang=js"
import style0 from "./RemittanceOperationManagementReport.vue?vue&type=style&index=0&id=cff9cd30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff9cd30",
  null
  
)

export default component.exports